/**
 * Для работы следует реализовать подобную схему:
 *
 * <div class="calculate-delivery" data-calculate-delivery-url="Url для расчета стоимости">
 *     <input class="calculate-delivery-input">
 *     <button class="calculate-delivery-button">
 *     <div class="calculate-delivery-message hidden"></div>
 * </div>
 *
 * Модуль использует Semantic UI, устанавливает кнопке на время расчета стоимости класс "loading".
 */

import '../../css/calculate_delivery.css';

var $calculateDeliveryModal = $('<div class="ui modal calculate-delivery-modal"><div class="content"></div></div>');

/**
 * Функция обрабатывает комментарий расчета
 * @param commentId
 * @param comment
 * @returns {{link: string, comment: string}}
 */
function processComment(commentId, comment) {
    var commentHtmlId = 'calculate-delivery-comment-' + commentId;
    return {
        link: '<span class="calculate-delivery-comment-mark calculate-delivery-comment-mark-right calculate-delivery-comment-mark-link" ' +
                    'data-calculate-delivery-comment-id="' + commentHtmlId + '">' + commentId + '</span>',
        comment: '<p id="' + commentHtmlId + '">' +
                 '<span class="calculate-delivery-comment-mark calculate-delivery-comment-mark-left">' + commentId + '</span>' +
                 '<span class="calculate-delivery-comment-text">' + comment + '</span>' +
                 '</p>'
    };
}


var failMessage = 'Не удалось рассчитать примерную стоимость доставки.';
/**
 * Функция показывает переданное сообщение в переданном контейнере
 * @param $messageContainer
 * @param [message]
 */
function showMessage($messageContainer, message) {
    if ($messageContainer instanceof jQuery) {
        $messageContainer.html(message).show();
    }
}

$('.calculate-delivery').each(function () {
    var $calculateDelivery = $(this),
        $calculateDeliveryButton = $calculateDelivery.find('.calculate-delivery-button'),
        $calculateDeliveryInput = $calculateDelivery.find('.calculate-delivery-input'),
        $messageContainer = $calculateDelivery.find('.calculate-delivery-message'),
        url = $calculateDelivery.data('calculateDeliveryUrl');
    $calculateDeliveryButton.on('click', function () {
        $messageContainer.hide();
        $calculateDeliveryButton.addClass('loading');
        $.ajax({
            url: url,
            method: 'post',
            data: {
                products_in_cart: JSON.stringify(window.productsInCart),
                postal_code: $calculateDeliveryInput.val()
            },
            complete: function (xhr) {
                $calculateDeliveryButton.removeClass('loading');
                if (xhr.responseText !== '0') {
                    try {
                        var result = JSON.parse(xhr.responseText);
                    } catch (e) {
                        showMessage($messageContainer, failMessage);
                        return;
                    }
                    if (result.calculation/* && result.calculation.length*/) {
                        var calculationResultContent = '<table class="calculate-delivery-result-table">',
                            commentId = 0,
                            comments = '',
                            processedComment;
                        for (var service in result.calculation) {
                            for (var n = 0; n < result.calculation[service].calculation_variants.length; n++) {
                                calculationResultContent += '<tr>';
                                if (n === 0) {
                                    calculationResultContent += '<td class="calculate-delivery-service-name" rowspan="' + result.calculation[service].calculation_variants.length + '">' + result.calculation[service].name;
                                    if (result.calculation[service].comment) {
                                        processedComment = processComment(++commentId, result.calculation[service].comment);
                                        calculationResultContent += processedComment.link;
                                        comments += processedComment.comment;
                                    }
                                    calculationResultContent += '</td>';
                                }
                                if (result.calculation[service].calculation_variants[n].name) {
                                    calculationResultContent += '<td class="calculate-delivery-variant-name">' + result.calculation[service].calculation_variants[n].name + "</td>";
                                    calculationResultContent += '<td class="calculate-delivery-price">';
                                } else {
                                    calculationResultContent += '<td class="calculate-delivery-price calculate-delivery-price-only" colspan="2">';
                                }
                                calculationResultContent += result.calculation[service].calculation_variants[n].price;
                                if (result.calculation[service].calculation_variants[n].comment) {
                                    processedComment = processComment(++commentId, result.calculation[service].calculation_variants[n].comment);
                                    calculationResultContent += processedComment.link;
                                    comments += processedComment.comment;
                                }
                                calculationResultContent += '</td>';
                                calculationResultContent += '</tr>';
                            }
                        }
                        calculationResultContent += "</table>";
                        if (comments) {
                            calculationResultContent += '<div class="calculate-delivery-comments">' + comments + '</div>';
                        }
                        $calculateDeliveryModal
                            .find('.content').html(calculationResultContent)
                                .find('.calculate-delivery-comment-mark-link').on('click', function () {
                                    document.getElementById($(this).data('calculateDeliveryCommentId')).scrollIntoView();
                                });
                        $calculateDeliveryModal.modal('show');
                    } else {
                        if (result.message !== undefined) {
                            showMessage($messageContainer, result.message);
                        } else {
                            showMessage($messageContainer, failMessage);
                        }
                    }
                } else {
                    showMessage($messageContainer, failMessage);
                }
            }
        });
    });
    $calculateDeliveryInput.keypress(function (event) {
        if (event.which === 13) {
            $messageContainer.hide();
            $calculateDeliveryButton.trigger('click');
            return false;
        }
    });
    $calculateDeliveryInput.on('focus', function () {
        $messageContainer.hide();
    })
});



// WEBPACK FOOTER //
// ./assets/javascript/calculate_delivery.js